import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Gift, Sparkles } from "lucide-react";
import { http } from "@/lib/api";

export default function GiftClaim() {
    const { code } = useParams();
    const [gift, setGift] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        http.get(`/gifts/${code}`)
            .then((r) => setGift(r.data))
            .catch((e) => setError(e.response?.data?.detail || "Cadeau introuvable"));
    }, [code]);

    if (error) {
        return (
            <div className="max-w-xl mx-auto text-center px-6 py-24" data-testid="gift-error">
                <h1 className="font-serif text-4xl mb-4">Cadeau introuvable</h1>
                <p className="text-muted-foreground">{error}</p>
            </div>
        );
    }

    if (!gift) return <div className="text-center py-24 text-muted-foreground">Chargement…</div>;

    return (
        <div className="max-w-2xl mx-auto px-6 py-20" data-testid="gift-claim-page">
            <div className="text-center mb-10">
                <Gift className="w-14 h-14 text-secondary mx-auto mb-4" />
                <div className="text-sm tracking-[0.25em] uppercase text-primary mb-4 font-medium">Cadeau reçu</div>
                <h1 className="font-serif text-5xl mb-4">Bonjour {gift.recipient_name}</h1>
                <p className="text-lg text-foreground/70">
                    <strong>{gift.sender_name}</strong> vous offre une séance de{" "}
                    <strong>{gift.session_name}</strong>.
                </p>
            </div>

            {gift.message && (
                <blockquote className="italic text-lg text-center border-l-4 border-secondary pl-6 py-4 my-8 bg-accent/40 rounded-r-2xl">
                    « {gift.message} »
                </blockquote>
            )}

            <div className="rounded-3xl border border-border/60 bg-card p-8 text-center">
                <Sparkles className="w-6 h-6 text-primary mx-auto mb-4" />
                <p className="mb-4 text-sm">Contactez-nous par email en indiquant votre code cadeau pour choisir votre créneau :</p>
                <div className="font-mono text-2xl bg-muted rounded-full px-6 py-3 inline-block mb-4 tracking-wider" data-testid="gift-code">
                    {gift.code}
                </div>
                <p className="text-sm text-muted-foreground">
                    Envoyez à <a href="mailto:info@foundation-of-light.com" className="text-primary underline">info@foundation-of-light.com</a>
                </p>
            </div>
        </div>
    );
}
